import React from "react";
import { AnimatePresence } from "framer-motion";
import { Route, Routes, useLocation } from "react-router-dom";
import HomePage from "../pages/home";
import ProductFamily from "../pages/product-family";
import ProductFamilyDetail from "../pages/product-family-detail";
import About from "../pages/about";
import News from "../pages/news";
import Contact from "../pages/contact";
import NewsDetail from "../pages/news-detail";
import ScrollToTop from "../components/ScrollToTop";

const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    <AnimatePresence>
      <ScrollToTop />
      <Routes key={location.pathname} location={location}>
        <Route path="/" element={<HomePage />} />
        <Route path="/urun-aileleri" element={<ProductFamily />} />
        <Route path="/product-families" element={<ProductFamily />} />
        <Route path="/urun-ailesi" element={<ProductFamilyDetail />} />
        <Route
          path="/product-family-detail"
          element={<ProductFamilyDetail />}
        />
        <Route path="/hakkimizda" element={<About />} />
        <Route path="/about" element={<About />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/haberler" element={<News />} />
        <Route path="/news" element={<News />} />
        <Route path="/haber-detay" element={<NewsDetail />} />
        <Route path="/news-detail" element={<NewsDetail />} />
        <Route path="/iletisim" element={<Contact />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/*" element={<HomePage />} />
        <Route path="/urun-aileleri/:slug" element={<ProductFamily />} />
        <Route path="/product-families/:slug" element={<ProductFamily />} />
      </Routes>
    </AnimatePresence>
  );
};

export default AnimatedRoutes;
